<!-- 人员通行授权页面 -->
<template>
  <div class="authorization-container tree-line-style">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left">
        <el-scrollbar
          class="flex-auto"
          style="margin-top: 10px; height: calc(100% - 40px)"
        >
          <el-tree
            ref="leftTree"
            :data="frame"
            :props="treeProps"
            class="gate-box"
            @node-click="treeNodeClick"
            :expand-on-click-node="false"
            :default-expand-all="false"
            :default-expanded-keys="expandedKeys"
            :highlight-current="true"
            node-key="thirdDeviceId"
          >
            <template slot-scope="{ node }">
              <element-tree-line
                :node="node"
                :showLabelLine="true"
                :indent="16"
                class="tree-line"
              >
                <span class="custom-tree-node">
                  <span :title="node.label" class="view-label">{{
                    node.label
                  }}</span>
                </span>
              </element-tree-line>
            </template>
          </el-tree>
        </el-scrollbar>
      </div>

      <!-- 右侧tab栏 -->
      <div class="section-mian_right">
        <ioc-tab-group
          ref="tabs"
          :class="personType.prop"
          :option="tabOption"
          @change="handleChange"
        ></ioc-tab-group>
        <!-- 头部按钮 -->
        <div
          class="section-mian__toolbar flex-row"
          v-if="personType.prop === 'staff' && isRoot"
        >
          <el-button
            type="primary"
            size="small"
            class="iss-operation-button"
            v-auth="'/personAuthorization/index:update'"
            @click="openAuthorizationDialog"
          >
            授权
          </el-button>
          <el-button
            type="primary"
            size="small"
            class="iss-operation-button"
            :loading="disabled"
            v-auth="'/personAuthorization/index:export'"
            @click="fetchDownLoadFile"
          >
            {{ disabled ? "导出中" : "导出" }}
          </el-button>
          <el-button
            type="primary"
            size="small"
            v-auth="'/personAuthorization/index:sync'"
            class="iss-operation-button"
            @click="syncAuthorization"
            >授权信息同步</el-button
          >
        </div>

        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="personTab"
            :data="tableData"
            :option="tableOption"
            :page="page"
            @row-cancle="closeDialog"
            @row-update="handleUpdate"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @selection-change="selectionChange"
            @size-change="changeSize"
          >
            <!-- 搜索框 自定义 -->
            <template slot="search_departmentCode">
              <div style="flex: 1; position: relative">
                <el-cascader
                  v-model="departmentValue"
                  :options="optionCasacder"
                  :props="casacderProps"
                  :show-all-levels="false"
                  collapse-tags
                  clearable
                  @change="handleChangeCascader"
                >
                  <template slot-scope="{ node, data }">
                    <span v-if="node.isLeaf">{{ data.label }}</span>
                  </template>
                </el-cascader>
              </div>
            </template>
            <!-- 表格按钮 自定义 -->
            <template slot="menu" slot-scope="scope">
              <!-- 取消授权和恢复授权功能废弃 -->
              <!-- <el-tooltip class="item"
                          effect="dark"
                          content="恢复授权"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           icon="iconfont-lunan icon-lunan-shouquan"
                           @click="restoreAuthorization(scope.row)"
                           v-if="scope.row.authStatus === '失效'"></el-button>
              </el-tooltip>
              <el-tooltip class="item"
                          effect="dark"
                          content="取消授权"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           icon="iconfont-lunan icon-lunan-weishouquan"
                           v-if="scope.row.authStatus === '已授权'"
                           @click="cancleAuthorization(scope.row)"></el-button>
              </el-tooltip> -->

              <el-tooltip
                class="item"
                effect="dark"
                content="修改"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-xiugai"
                  v-if="personType.prop === 'staff'"
                  v-auth="'/personAuthorization/index:update'"
                  :disabled="scope.row.authStatus === '已授权'"
                  @click="handleEdit(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
            </template>
            <!-- 表格列 自定义 -->
            <template slot="facePicFileCode" slot-scope="scope">
              <img
                :src="getImgPath(scope.row.facePicFileCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px"
                @click="
                  showViewer(getImgPath(scope.row.facePicFileCode), $event)
                "
              />
            </template>
            <!-- 失效红色色 已授权高亮展示 -->
            <template slot="authStatus" slot-scope="scope">
              <span
                v-if="scope.row.authStatus === '失效'"
                style="color: red; cursor: pointer"
                @click="handleView(scope.row, scope.index)"
                >{{ scope.row.authStatus }}</span
              >
              <span
                v-else
                style="color: #00e8bb; cursor: pointer"
                @click="handleView(scope.row, scope.index)"
                >{{ scope.row.authStatus }}</span
              >
            </template>
            <!-- 查看详情表单 自定义 -->
            <template slot="facePicFileCodeView" slot-scope="scope">
              <img
                :src="getImgPath(scope.row.facePicFileCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px"
              />
            </template>
            <!-- 详情页面中的授权信息列表 -->
            <template slot="viewFormSet">
              <h4 class="info-title">授权信息</h4>
              <ioc-table
                ref="crud"
                :data="detailData"
                :option="detailoption"
                :page="recordPage"
                @current-change="selectRecordPage"
                @size-change="changeRecordSize"
                class="table-box"
              >
                <!-- 失效红色色 已授权高亮展示 -->
                <template slot="authStatus" slot-scope="scope">
                  <span
                    v-if="scope.row.authStatus === '失效'"
                    style="color: red"
                    >{{ scope.row.authStatus }}</span
                  >
                  <span v-else style="color: #00e8bb">{{
                    scope.row.authStatus
                  }}</span>
                </template>
              </ioc-table>
            </template>
          </ioc-table>
          <viewer
            @inited="inited"
            :images="viewerPhotos"
            class="viewer"
            ref="viewer"
          >
            <img v-for="src in viewerPhotos" :src="src" :key="src" />
          </viewer>
        </div>
      </div>
      <!-- 人员选择弹框 -->
      <authority-dialog
        ref="authorization"
        @refreshList="getList"
        :departmentData="optionCasacder"
        :treeData="gateOptions"
      ></authority-dialog>
    </div>
  </div>
</template>
<script>
import { api } from "../api/index";
import utils from "@src/common/utils";
import { Dic, Bus, Dates } from "$utils";
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../config/table";
import authorityDialog from "../components/authorityDialog";
import detailoption from "../config/detailOptions";
import ElementTreeLine from "element-tree-line";
export default {
  components: {
    authorityDialog,
    ElementTreeLine
  },
  data() {
    return {
      disabled: false,
      optionCasacder: [],
      casacderProps: { multiple: true },
      viewerPhotos: [],
      viewerInstance: null,
      //员工与访客分类
      personType: {},
      tabOption: {
        column: [
          {
            label: "员工通行授权",
            prop: "staff",
            typeId: "1"
          },
          {
            label: "外来人员通行授权",
            prop: "visitor",
            typeId: "2"
          }
        ]
      },
      tableOption: tableOption(true, true),
      detailoption: detailoption(),
      // 分页属性设置
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      recordPage: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      tableData: [],
      departmentValue: [],
      // 员工用户组列表查询参数
      searchParams: {},
      // 选择的人员code
      checkAuthCodes: [],
      isRoot: false,
      // 树的props
      treeProps: {
        children: "subDeviceInfoList",
        label: "thirdDeviceName",
        isLeaf: "parentDeviceId"
      },
      // 设备树的数据
      frame: [
        {
          thirdDeviceName: "人脸道闸",
          subDeviceInfoList: [],
          parentDeviceId: "200000006",
          parentDeviceIds: "200000006",
          systemId: "200000006",
          deviceID: "200000006"
        }
      ],
      // 闸机设备的第三方ID
      thirdDeviceId: "",
      // 默认展开的节点的 key 的数组
      expandedKeys: [],
      gateOptions: [],
      detailData: [],
      currentCode: ""
    };
  },
  created() {
    // 默认进入页面选中第一种分类方式
    this.personType = this.tabOption.column[0];
    this.getAccessDeviceInfoTree();
  },
  mounted() {
    this.getDepartmentTree();
  },
  methods: {
    fetchDownLoadFile() {
      const params = {};
      let result = [];
      this.departmentValue.forEach((item) => {
        result.push(item[item.length - 1]);
      });
      params.thirdDeviceId = this.thirdDeviceId;
      params.personnelType = 1;
      params.name = this.searchParams.name;
      params.phone = this.searchParams.phone;
      params.status = this.searchParams.status;
      params.authStatus = this.searchParams.authStatus;
      params.pageNum = this.page.pageNum;
      params.pageSize = this.page.pageSize;
      if (this.personType.prop === "staff") {
        params.departmentCodeList = result;
      }
      if (
        this.searchParams.passageTime &&
        this.searchParams.passageTime.length
      ) {
        params.effectiveTime = this.searchParams.passageTime[0]
          ? Dates.dayjs(this.searchParams.passageTime[0]).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "";
        params.expirationTime = this.searchParams.passageTime[1]
          ? Dates.dayjs(this.searchParams.passageTime[1]).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "";
      }
      // 兼容IE
      this.disabled = true;
      this.$fetchDownLoad(api.person.exportTurnstilegateAuthorityList, params, {
        responseType: "arraybuffer"
      }).then((response) => {
        setTimeout(() => {
          this.disabled = false;
        }, 500);
        const content = response.data;
        const blob = new Blob([content], { type: "application/zip" });
        const fileName =
          "人脸授权信息" +
          Dates.format(Date.now(), "yyyyMMddHHmmssms") +
          ".zip";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    // 获得人脸闸机树的数据
    getAccessDeviceInfoTree() {
      const params = {
        deviceType: "1"
      };
      //闸机接口
      this.$fetch(api.device.getGateTree, params).then((res) => {
        if (res.success) {
          this.gateOptions = res.returnObj;
          this.frame[0].subDeviceInfoList = res.returnObj;
          this.thirdDeviceId = this.frame[0].subDeviceInfoList[0].thirdDeviceId;
          this.expandedKeys = [
            this.frame[0].subDeviceInfoList[0].thirdDeviceId
          ];
          console.log(this.frame);
          this.$nextTick(function () {
            this.$refs.leftTree.setCurrentKey(this.thirdDeviceId);
            this.getList(1);
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 获取部门树结构
    getDepartmentTree() {
      const param = {};
      this.$fetch(api.device.departmentTree, param).then((res) => {
        if (res.success) {
          this.optionCasacder = this.menusDataPro2(res.returnObj);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //递归部门树结构
    menusDataPro2(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.label = item.departmentName;
          entity.value = item.departmentCode;
          entity.isLeaf = !item.subDepartmentList;
          if (item.subDepartmentList && item.subDepartmentList.length) {
            entity.children = self.menusDataPro2(item.subDepartmentList);
          }
          result.push(entity);
        });
        return result;
      }
    },

    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(src, e) {
      // this.viewerPhotos = [e.target.src];
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src
      ];
      this.viewerInstance.show();
    },

    // 切换选项卡
    handleChange(column) {
      this.personType = column;
      if (this.personType.typeId === "1") {
        this.tableOption = tableOption(true, true);
        // this.getList(1);
      } else {
        this.tableOption = tableOption(false, true);
        // this.getList(2);
      }
      this.$nextTick(() => {
        this.$refs.personTab.reset();
      });
    },
    // 级联下拉框change事件
    handleChangeCascader(value) {},
    // 获取列表
    getList(personnelType) {
      const params = {};
      let result = [];
      this.departmentValue.forEach((item) => {
        result.push(item[item.length - 1]);
      });
      params.thirdDeviceId = this.thirdDeviceId;
      params.personnelType = personnelType;
      params.name = this.searchParams.name;
      params.phone = this.searchParams.phone;
      params.status = this.searchParams.status;
      params.authStatus = this.searchParams.authStatus;
      params.pageNum = this.page.pageNum;
      params.pageSize = this.page.pageSize;
      if (this.personType.prop === "staff") {
        params.departmentCodeList = result;
      }
      if (
        this.searchParams.passageTime &&
        this.searchParams.passageTime.length
      ) {
        params.effectiveTime = this.searchParams.passageTime[0]
          ? Dates.dayjs(this.searchParams.passageTime[0]).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "";
        params.expirationTime = this.searchParams.passageTime[1]
          ? Dates.dayjs(this.searchParams.passageTime[1]).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "";
      }
      // const loading = this.$loading({
      //   lock: true,
      //   text: "请求中",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
      this.$fetch(api.person.getAuthorityList, params).then((response) => {
        // setTimeout(() => {
        //   loading.close();
        // }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        response.returnObj.list.forEach((item) => {
          if (item.authStatus === "2") {
            item.authStatus = "失效";
          } else {
            item.authStatus = "已授权";
          }
        });
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.personTab.selectClear();
      });
    },
    // 授权按钮
    openAuthorizationDialog() {
      this.$refs.authorization.open();
    },
    // 同步授权信息按钮
    syncAuthorization() {
      this.$confirm("您确定要同步授权信息吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$fetch(api.person.syncAuthorityList).then((res) => {
          if (res.success) {
            this.$message.success("同步成功");
            this.getList(1);
          } else {
            if (res.msgCode === "103009002010001") {
              this.$message.success(res.msgContent);
            } else {
              this.$message.error(res.msgContent);
            }
          }
        });
      });
    },
    // 表格列修改按钮
    handleEdit(row, index) {
      this.$nextTick(() => {
        this.$refs.personTab.rowEdit(row, index);
      });
    },

    handleView(row, index) {
      this.$refs.personTab.rowView(row, index);
      this.currentCode = row.authCode;
      this.$nextTick(() => {
        this.getDetailData(this.currentCode);
      });
    },
    // 访客取消授权按钮
    cancleAuthorization(row) {
      this.$confirm("您确定取消该人员的授权么?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          authCode: row.authCode,
          authStatus: "2"
        };

        // 调用修改授权的接口
        this.$fetch(api.person.updateAuthority, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.$message.success(response.msgContent);
            if (this.personType.prop === "staff") {
              this.getList(1);
            } else {
              this.getList(2);
            }
          }
        });
      });
    },
    // 访客恢复授权按钮
    restoreAuthorization(row) {
      this.$confirm("您确定恢复该人员的授权么?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          authCode: row.authCode,
          authStatus: "1",
          effectiveTime: row.effectiveTime,
          expirationTime: row.expirationTime
        };
        // 调用授权的接口
        this.$fetch(api.person.updateAuthority, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.$message.success(response.msgContent);
            if (this.personType.prop === "staff") {
              this.getList(1);
            } else {
              this.getList(2);
            }
          }
        });
      });
    },

    handleUpdate(updateInfo, done) {
      let params = {
        authCode: updateInfo.authCode,
        effectiveTime: updateInfo.effectiveTime
          ? Dates.dayjs(updateInfo.effectiveTime).format("YYYY-MM-DD HH:mm:ss")
          : "",
        expirationTime: updateInfo.expirationTime
          ? Dates.dayjs(updateInfo.expirationTime).format("YYYY-MM-DD HH:mm:ss")
          : ""
      };
      // 调用授权的接口
      this.$fetch(api.person.updateAuthority, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          this.$message.success(response.msgContent);
          if (this.personType.prop === "staff") {
            this.getList(1);
          } else {
            this.getList(2);
          }
          done();
        }
      });
    },

    closeDialog() {},

    // 查询按钮事件
    searchResult(param) {
      if (this.personType.prop === "staff") {
        this.searchParams = Object.assign(param);
        this.page.pageNum = 1;
        this.getList(1);
      } else {
        this.searchParams = Object.assign(param);
        this.page.pageNum = 1;
        this.getList(2);
      }
    },
    // 重置按钮
    resetQuery() {
      this.departmentValue = [];
      if (this.personType.prop === "staff") {
        this.getList(1);
      } else {
        this.getList(2);
      }
    },

    // 树的子节点点击事件
    treeNodeClick(data, node) {
      // 只有第一级节点才可点击查询数据
      if (node.level === 2) {
        this.thirdDeviceId = data.thirdDeviceId;
        // 点击树节点后 查询列表
        if (this.personType.prop === "staff") {
          this.getList(1);
        } else {
          this.getList(2);
        }
      } else if (node.level === 1) {
        this.thirdDeviceId = "";
        if (this.personType.prop === "staff") {
          this.getList(1);
        } else {
          this.getList(2);
        }
      }
      if (node.level === 1) {
        // 只有根节点才展示授权按钮
        this.isRoot = true;
      } else {
        this.isRoot = false;
      }
    },

    // 当选择项发生变化时会触发该事件
    selectionChange(items) {
      this.checkAuthCodes = items.map((item) => {
        return item.authCode;
      });
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.pageNum = val;
      // 调用列表接口
      if (this.personType.prop === "staff") {
        this.getList(1);
      } else {
        this.getList(2);
      }
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      //调用列表接口
      if (this.personType.prop === "staff") {
        this.getList(1);
      } else {
        this.getList(2);
      }
    },
    getDetailData(code) {
      let params = {
        authCode: code,
        pageNum: this.recordPage.pageNum,
        pageSize: this.recordPage.pageSize
      };
      // 调用授权的接口
      this.$fetch(api.person.getRecordList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        response.returnObj.list.forEach((item) => {
          if (item.authStatus === "2") {
            item.authStatus = "失效";
          } else {
            item.authStatus = "已授权";
          }
        });
        this.detailData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.recordPage.total = response.returnObj
          ? response.returnObj.total
          : 0;
      });
    },
    selectRecordPage(val) {
      this.recordPage.pageNum = val;
      this.getDetailData(this.currentCode);
    },
    changeRecordSize(val) {
      this.recordPage.pageNum = 1;
      this.recordPage.pageSize = val;
      this.getDetailData(this.currentCode);
    }
  }
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.authorization-container {
  width: 100%;
  height: 100%;
  .el-table__fixed-right-patch {
    display: none;
  }

  .el-tabs__nav {
    width: 100% !important;
    display: flex;
    justify-content: space-around;
  }
  .visitor {
    .el-tabs__active-bar {
      width: 50% !important;
      transform: translateX(100%) !important;
    }
  }
  .el-tabs__active-bar {
    width: 50% !important;
  }
}

</style>
